module.exports = __webpack_public_path__ + "img/scene5copysub.e0db481c.png";